import { getAggSubscriptionEndpoint } from './utils';

/**
 * Workspace context for a host's /subscriptions/<product>/workspace/<workspaceId> route.
 * The host must configure Edge extraction for this route. This does not provision a route.
 * Values are raw ARI owner and workspace resource ID components, not an ARI or encoded path.
 */
export type SubscriptionShardingContext = Readonly<{
	type: 'workspace';
	product: string;
	workspaceId: string;
}>;

/** Resolve routing once per observer; connection retries keep the resulting URL. */
export function getSubscriptionUrl(context: unknown): string {
	if (
		typeof context !== 'object' ||
		context === null ||
		!('type' in context) ||
		context.type !== 'workspace' ||
		!('product' in context) ||
		typeof context.product !== 'string' ||
		!('workspaceId' in context) ||
		typeof context.workspaceId !== 'string'
	) {
		throw new Error('Invalid subscription sharding context');
	}
	return `${getAggSubscriptionEndpoint()}/${encodeContextSegment(context.product)}/workspace/${encodeContextSegment(context.workspaceId)}`;
}

function encodeContextSegment(value: string): string {
	if (!value || value === '.' || value === '..') {
		throw new Error('Invalid subscription sharding context segment');
	}
	return encodeURIComponent(value);
}
